import React from "react";
export default function generateAvatar(name) {
  return (
    <img
      src={`https://avatars.dicebear.com/api/${"initials"}/${name}.svg`}
      alt="dicebar"
    />
  );
}
